import React, { createContext, useContext, useState, useCallback } from 'react';
import { ContactForm } from '../components/ContactForm';
import { Toaster } from '../components/ui/sonner';

const ContactContext = createContext({ openContactForm: () => {} });

export const useContact = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openContactForm = useCallback(() => setIsOpen(true), []);
  const closeContactForm = useCallback(() => setIsOpen(false), []);

  return (
    <ContactContext.Provider value={{ openContactForm }}>
      {children}
      <ContactForm isOpen={isOpen} onClose={closeContactForm} />
      <Toaster />
    </ContactContext.Provider>
  );
};
